export const RELOAD_INTERVAL = 2000;
